export default "__VITE_ASSET__SSC55duh__"